import { Card, Col, Row, Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Label } from '../../components';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SelectableListModal from '../../components/SelectableListModal';
import { errorHandler, gruposSistema } from '../../utils';
import { instanceRef } from '../../utils/axios';

const columns = [
  {
    title: 'Verificador',
    dataIndex: 'nombres',
    key: 'nombres'
  },
  {
    title: 'Rol',
    dataIndex: 'grupo',
    key: 'grupo',
    render: (grupo) => gruposSistema[grupo]
  }
];

const Verificadores = () => {
  const {
    params: { id: idTipo, tipo: tipoParam }
  } = useRouteMatch();
  const [loading, setLoading] = useState();
  const [usuarios, setUsuarios] = useState([]);
  const [verificadores, setVerificadores] = useState([]);
  const [newVerificadores, setNewVerificadores] = useState();
  const [tipo, setTipo] = useState();
  const [urlUsuarios, setUrlUsuarios] = useState();

  /* const columnsEditable = [
    {
      title: 'Verificador',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Rol',
      dataIndex: 'grupo',
      key: 'grupo',
      render: (grupo) => gruposSistema[grupo]
    }
  ]; */

  const getVerificadores = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get('verificador', {
        params: {
          tipo: tipoParam,
          id: idTipo
        }
      });
      if (response.data?.data) {
        if (response.data?.data.length > 0) {
          const verificadorUsuarioList = response.data?.data.map(
            (item) => item.usuario
          );
          setVerificadores(verificadorUsuarioList);
        }
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const getUsuarios = async () => {
    setLoading(true);
    try {
      const url =
        tipoParam === 'aseguradoraProducto'
          ? `auth/users/aseguradora?id=${tipo.idAseguradora}`
          : `auth/users?id=${tipo.idEmpresa}`;
      setUrlUsuarios(url);

      const response = await instanceRef.instance.get(url, {});
      if (response.data?.data) {
        // Filtrar por el id de la Aseguradora seleccionada
        const list = response.data?.data.rows.map((item) => {
          return {
            label: item.nombres,
            value: item.id,
            checked: false
          };
        });
        setUsuarios(list);
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const getTipo = async () => {
    setLoading(true);
    try {
      let urlTipo = '';
      if (tipoParam === 'aseguradoraProducto') {
        urlTipo = `/aseguradoraproducto/aseguradoraproducto/${idTipo}`;
      } else if (tipoParam === 'aseguradoraEmpresaProducto') {
        urlTipo = `/aseguradoraempresaproducto/${idTipo}`;
      } else if (tipoParam === 'empresaProducto') {
        urlTipo = `/empresaProducto/${idTipo}`;
      }

      if (urlTipo) {
        const response = await instanceRef.instance.get(urlTipo, {});
        const data = response.data?.data;
        if (data) {
          if (tipoParam === 'aseguradoraProducto') {
            const tipoObj = {
              id: data.id,
              idAseguradora: data.aseguradora.id,
              tipo: data.aseguradora.descripcion || '',
              producto: data.producto
            };
            setTipo(tipoObj);
          } else if (tipoParam === 'aseguradoraEmpresaProducto') {
            const tipoObj = {
              id: data.aseguradoraEmpresa.id,
              idEmpresa: data.aseguradoraEmpresa.empresa.id,
              idAseguradora: data.aseguradoraEmpresa.aseguradora.id,
              tipo: data.aseguradoraEmpresa.aseguradora.descripcion || '',
              producto: data.producto
            };
            setTipo(tipoObj);
          } else if (tipoParam === 'empresaProducto') {
            const tipoObj = {
              id: data.id,
              idEmpresa: data.empresa.id,
              tipo: data.empresa.nombre_corto || '',
              producto: data.producto
            };
            setTipo(tipoObj);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const prepareData = () => {
    const verificadoresToUpdate = newVerificadores.map((item) => {
      const verificadorEncontrado = verificadores.find(
        (verificador) => verificador.id === item
      );
      let verificador = {
        id_usuario: item
      };
      if (verificadorEncontrado) {
        verificador = {
          ...verificador,
          id: verificadorEncontrado.id
        };
      }
      if (tipoParam === 'aseguradoraProducto') {
        verificador = {
          ...verificador,
          id_aseguradora_producto: idTipo
        };
      } else if (tipoParam === 'aseguradoraEmpresaProducto') {
        verificador = {
          ...verificador,
          id_aseguradora_empresa_producto: idTipo
        };
      } else if (tipoParam === 'empresaProducto') {
        verificador = {
          ...verificador,
          id_empresa_producto: idTipo
        };
      }

      return verificador;
    });
    return verificadoresToUpdate;
  };

  const updateVerificador = async (data) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.post(
        `verificador/asignar/${tipoParam}/${idTipo}`,
        data
      );
      if (response) {
        getVerificadores();
      }

      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const headTable = () => {
    return {
      title: () =>
        usuarios.length > 0 && (
          <Row gutter={8}>
            {' '}
            <Col flex="none">
              <SelectableListModal
                textButton="Verificadores"
                title="Verificadores"
                listChecked={verificadores}
                isMultiple
                setNewList={setNewVerificadores}
                columnsData={columns}
                url={urlUsuarios}
                width={800}
              />
            </Col>
          </Row>
        )
    };
  };

  useEffect(() => {
    if (tipo) {
      getUsuarios();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo]);

  useEffect(() => {
    if (newVerificadores) {
      const data = prepareData();
      updateVerificador(data);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newVerificadores]);

  useEffect(() => {
    getTipo();
    getVerificadores();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveContainer size="large">
        <Card
          title={
            tipo &&
            `Verificadores - ${tipo.tipo} - ${tipo.producto.descripcion}`
          }
          style={{ textAlign: 'left' }}
        >
          <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
            <div style={{ maxWidth: '500px' }}>
              {usuarios.length > 0 ? (
                <Table
                  fixed
                  scroll={false}
                  style={{ width: '100%' }}
                  {...headTable()}
                  bordered
                  dataSource={verificadores}
                  columns={columns}
                  pagination={false}
                  size="small"
                  rowKey={(record) => record.id}
                />
              ) : (
                tipo &&
                tipo.tipo && (
                  <Row gutter={8}>
                    {' '}
                    <Col flex="none">
                      <Label>{`No existen usuarios asociados para ${tipo.tipo}`}</Label>
                    </Col>
                  </Row>
                )
              )}
            </div>
          </Spin>
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default Verificadores;
